import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

/**
 * Author Profile widget (section 3002). Only presentation config is persisted —
 * `author_id` points at the author row, whose content is joined server-side.
 */
export interface IAuthorProfilePayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  author_id?: number | string | null;
  [key: string]: unknown;
}

export async function createAuthorProfile(payload: IAuthorProfilePayload) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.AUTHOR_PROFILE.CREATE,
      payload,
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateAuthorProfile(
  id: number,
  payload: IAuthorProfilePayload,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.AUTHOR_PROFILE.UPDATE(id),
      payload,
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
